// FUNÇÕES/MÓDULOS SITE
import HoverBackgroundGradient from './modules/Animation/hover_bg-gradient'
import AnimationElements  from './modules/Animation/enterElements'
import ImageEnter from './modules/Animation/imageEnter'
import ImagesHovers from './modules/Animation/imageHovers'
import newsletter from './modules/Forms/newsletter'
import { BlogSection } from './modules/Components/blogSection'
// import ScrollSmooth from './modules/Animation/scrollLenis'
// import AnchorLinks from './modules/Utils/anchor_links'
// import Footer from './modules/Layouts/footer'

newsletter();

// Animations
// ScrollSmooth()
AnimationElements()
HoverBackgroundGradient()
ImageEnter()
ImagesHovers()
BlogSection();

// Utils
// AnchorLinks()

// Layout
// Footer()


// whatsapp floating btn opacity
function iconOpacity() {
    if ( window.scrollY >= 100 ) {
        $('#floating').css({ opacity: '1' });
    } else {
        $('#floating').css({ opacity: '0' });
    }
}

$(window).on('scroll', iconOpacity);

// header links 
$(function() {
    if ( document.querySelector('main#home' ) !== null ) { // verifica se está na página inicial
        let links = document.querySelectorAll('#header .nav-link');

        links.forEach((link, i) => {
            // define os links do header enquanto na home
            if (i === 1) {
                link.href = "#quem-somos";
            }
            if (i === 2) {
                link.href = "#servicos";
            }
            if (i === 4) {
                link.href = "#clientes";
            }
            if (i === 6) {
                link.href = "#contato";
            }
        });
    }
});

// portfolio show more btn
$('.portfolio a.button').on('click', () => {
    setTimeout(() => {
        let newCards = document.querySelectorAll('.card-item');
    
        newCards.forEach(card => {
            card.style.opacity = '1'
        })
    }, 400)
})